import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
export type StyleProps = {};
export const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
      padding: 32,
      background: '#fff',
    },
  })
);
